export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const DELETE_INGREDIENT = 'DELETE_INGREDIENT';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const INGREDIENTS_ERROR = 'INGREDIENTS_ERROR';
export const ADD_FAMILY = 'ADD_FAMILY';
export const GET_FAMILIES = 'GET_FAMILIES';
export const ADD_FAMILY_SUCCESS = 'ADD_FAMILY_SUCCESS'
export const SET_ALL_INGREDIENTS = 'SET_ALL_INGREDIENTS'


